import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  key: 0,
  class: "col-sm-12 text-center"
}
const _hoisted_3 = { class: "me-2 text-danger" }
const _hoisted_4 = {
  key: 1,
  class: "col-sm-12 text-center"
}
const _hoisted_5 = { class: "me-2 text-success" }
const _hoisted_6 = { class: "col-sm-12 mt-2" }
const _hoisted_7 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "text-capitalize-first" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { colspan: "3" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  colspan: "4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.withdrawal_whitelist'),
    "dialog-class": "modal-lg",
    modelValue: _ctx.modal !== null,
    "footer-class": "",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($event === false && (_ctx.modal = null)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, { ref: "loader" }, {
        default: _withCtx(() => [
          _createVNode(_component_ConfirmModal, { ref: "confirmDelete" }, null, 512),
          (_ctx.account)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_ctx.account.withdrawalWhitelistsEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.whitelists_disabled')), 1),
                      (!_ctx.isMerchantOperator)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.enable()), ["prevent"])),
                            type: "button",
                            class: "btn btn-sm btn-outline-dark"
                          }, _toDisplayString(_ctx.helper.trans('labels.enable')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.whitelists_enabled')), 1),
                      (!_ctx.isMerchantOperator)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.disable()), ["prevent"])),
                            type: "button",
                            class: "btn btn-sm btn-outline-danger"
                          }, _toDisplayString(_ctx.helper.trans('labels.disable')), 1))
                        : _createCommentVNode("", true)
                    ])),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.address.usdt')), 1),
                        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.created_at')), 1),
                        _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.deleted_at')), 1),
                        _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.withdrawalWhitelists, (item) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(item.address), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.createdAt)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.deletedAt)), 1),
                          _createElementVNode("td", null, [
                            (!item.deletedAt)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.remove(item)),
                                  class: "btn btn-sm btn-outline-danger text-nowrap float-end"
                                }, _cache[6] || (_cache[6] = [
                                  _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                ]), 8, _hoisted_11))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 256)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newItems, (item) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", _hoisted_12, [
                            _createVNode(_component_FormInputWrapper, {
                              errors: _ctx.getErrors(`${item.id}_address`)
                            }, {
                              default: _withCtx((parentProps) => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass([parentProps.class, "form-control form-control-sm"]),
                                  "onUpdate:modelValue": ($event: any) => ((item.address) = $event)
                                }, null, 10, _hoisted_13), [
                                  [_vModelText, item.address]
                                ])
                              ]),
                              _: 2
                            }, 1032, ["errors"])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.cancel(item)),
                              class: "btn btn-sm btn-outline-dark text-nowrap float-end"
                            }, _cache[7] || (_cache[7] = [
                              _createElementVNode("i", { class: "fa fa-cancel" }, null, -1)
                            ]), 8, _hoisted_14),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.save(item)),
                              class: "btn btn-sm btn-outline-success text-nowrap me-2 float-end"
                            }, _cache[8] || (_cache[8] = [
                              _createElementVNode("i", { class: "fa fa-save" }, null, -1)
                            ]), 8, _hoisted_15)
                          ])
                        ]))
                      }), 256)),
                      _createElementVNode("tr", null, [
                        (!_ctx.isMerchantOperator)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                              _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.add()), ["prevent"])),
                                type: "button",
                                class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first w-100"
                              }, [
                                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-plus" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.add')), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modal = null)),
        class: "btn btn-outline-danger btn-sm text-capitalize-first float-end"
      }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}